import { put, call, delay } from "redux-saga/effects";
import { POST, GET, PUT, DELETE } from "../../../../services/api";
import { toast } from "react-toastify";

export function* listLicenses(action) {
  console.log("listLicenses action", action)
  try {
    yield put({ type: "LICENSES_REQUEST" });
    const result = yield call(GET, { endpoint: `/licenses?per_page=${action.payload.perPage}&page=${action.payload.page}&search=${action.payload?.search}`, });

    console.log("listLicenses result", result?.data?.data)

    yield put({ type: "LICENSES_SUCCESS", payload: result?.data?.data });
  } catch (err) {

  }
}

export function* addLicenses(action) {
  yield put({ type: "LICENSES_ADD_REQUEST" });
  //yield delay(200);
  const result = yield call(POST, { endpoint: `/licenses`, data: action.payload });
  if (result === false) {
    yield put({ type: "LICENSES_ADD_ERROR" });
  } else {
    yield put({ type: "LICENSES_ADD_SUCCESS", payload: result?.data?.data });
  }
}


export function* updateLicenses(action) {
  yield put({ type: "LICENSES_UPDATE_REQUEST" });
  //yield delay(200);
  const result = yield call(PUT, { endpoint: `/licenses/${action.payload.id}`, data: action.payload });
  if (result === false) {
    yield put({ type: "LICENSES_UPDATE_ERROR" });
  } else {
    yield put({ type: "LICENSES_UPDATE_SUCCESS", payload: result?.data?.data });
  }
  yield put({ type: "LICENSES_UPDATE_RESET" });
}


export function* deleteLicenses(action) {
  yield put({ type: "LICENSES_DELETE_REQUEST" });
  //yield delay(200);
  const result = yield call(DELETE, { endpoint: `/licenses/${action.payload}` });
  if (result === false) {
    yield put({ type: "LICENSES_DELETE_ERROR" });
  } else {
    yield put({ type: "LICENSES_DELETE_SUCCESS", payload: result?.data?.data });
  }
}


export function* listCodes(action) {


  yield put({ type: "SERIALS_REQUEST" });
  const result = yield call(GET, { endpoint: `/codes/${action.payload.id}?per_page=${action.payload.perPage}&page=${action.payload.page}&search=${action.payload?.search}&used=${action.payload?.used}`, });

  if (result === false) {
    yield put({ type: "SERIALS_ERROR" });
  } else {
    yield put({ type: "SERIALS_SUCCESS", payload: result?.data?.data });
  }
}

export function* addCodes(action) {

  // yield put({ type: "CODES_ADD_REQUEST" });
  // //yield delay(200);
  // const result = yield call(POST, { endpoint: `/codes`, data: { licenseId: action.payload.id, serialNumber: action.payload.code } });
  // if (result === false) {
  //   yield put({ type: "CODES_ADD_ERROR" });
  // } else {
  //   yield put({ type: "CODES_ADD_SUCCESS", payload: result?.data?.data });
  // }


  yield put({ type: "CODES_ADD_REQUEST" });
  const raw = action.payload.code;
  const codes = Array.isArray(raw)
    ? raw
    : String(raw || "")
        .split(/[\n\r,;]+/)
        .map((c) => c.trim())
        .filter(Boolean);
  try {
    for (const code of codes) {
      const trimmedCode = typeof code === "string" ? code.trim() : String(code).trim();
      if (!trimmedCode) continue;
      yield call(POST, { endpoint: `/codes`, data: { licenseId: action.payload.id, serialNumber: trimmedCode } });
    }
    yield put({ type: "CODES_ADD_SUCCESS", payload: "result?.data?.data" });
  } catch (error) {
    yield put({ type: "CODES_ADD_ERROR", payload: " code: trimmedCode" });
  }

}

export function* updateCodes(action) {
  yield put({ type: "CODES_UPDATE_REQUEST" });
  //yield delay(200);
  const result = yield call(PUT, { endpoint: `/codes/${action.payload.id}`, data: action.payload.code });
  if (result === false) {
    yield put({ type: "CODES_UPDATE_ERROR" });
  } else {
    yield put({ type: "CODES_UPDATE_SUCCESS", payload: result?.data?.data });
  }
  yield put({ type: "CODES_UPDATE_RESET" });
}

export function* deleteCodes(action) {
  yield put({ type: "CODES_DELETE_REQUEST" });
  //yield delay(200);
  const result = yield call(DELETE, { endpoint: `/codes/${action.payload}` });
  if (result === false) {
    yield put({ type: "CODES_DELETE_ERROR" });
  } else {
    yield put({ type: "CODES_DELETE_SUCCESS", payload: result?.data?.data });
  }
}
